import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  status: null,
  message: null,
  data: null,
};

const sectorObservationReducer = createReducer(initialState, {
  SECTOR_OBSERVATION_REQ: (state) => {
    state.loading = true;
    state.user = null;
  },
  SECTOR_OBSERVATION_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  SECTOR_OBSERVATION_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default sectorObservationReducer;
